/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SafeToken, SafeTokenInterface } from "../SafeToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "rescueToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type SafeTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SafeTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SafeToken__factory extends ContractFactory {
  constructor(...args: SafeTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    owner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SafeToken> {
    return super.deploy(owner, overrides || {}) as Promise<SafeToken>;
  }
  getDeployTransaction(
    owner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(owner, overrides || {});
  }
  attach(address: string): SafeToken {
    return super.attach(address) as SafeToken;
  }
  connect(signer: Signer): SafeToken__factory {
    return super.connect(signer) as SafeToken__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SafeTokenInterface {
    return new utils.Interface(_abi) as SafeTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SafeToken {
    return new Contract(address, _abi, signerOrProvider) as SafeToken;
  }
}
